import * as d3 from 'd3-selection'
import fontSize from './font-size.js'
import yPos from './y-text-position.js'

export default function (dimensions) {

  let draw = function (selection) {
    selection.each(function () {
      // Add a group
      let group = d3.select(this)
                          .selectAll('g.text-group-units').data(function (d) {
                            return d.units && // Must have units
                                   d.value && d.value.formatted && // And showing a value
                                   !d.explanation // But not if there's an explanation
                                   ? [d.units] : []
                          })
        , _group = group.enter()
                                  .append('g')
                                    .attr('class', 'text-group-units')
                                    .merge(group)
                                    .attr('transform', `translate(${dimensions.padding.left},0)`)

      let units = _group
                    .selectAll('text.units').data(d => [d])

      units.enter()
           .append('text')
           .attr('class', 'units')
           .merge(units)
             .text(String)
             .style('font-size', function (d) {
               // Determine font size based on 50% of width, so it matches the actual value container width
               return fontSize(this, d, 'units', dimensions.viewbox.width / 2, 6)
             })
             .attr('y', function (d) {
               return yPos(parseFloat(d3.select(this).style('font-size')), dimensions.header.height * 2.9)
             })

      group.exit().remove()
    })
  }
  return draw
}
